import React from 'react';
import { Button, ButtonProps } from '@fiverr-private/button';
import { useFormState } from '@fiverr-private/forms';

interface FormSubmitButtonProps {
    label: string;
    loading: ButtonProps['loading'];
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({ label, loading }) => {
    const { isValidating, isValid } = useFormState();
    return (
        <Button loading={isValidating || loading} disabled={!isValid} type="submit" fullWidth>
            {label}
        </Button>
    );
};
